import { LecteurAction, LecteurActionTypes } from "./lecteur.action";
import { Action } from "@ngrx/store";
import { ReponseLecteur } from "@featuresAY/shared/lecteur/reponse.lecteur";

export interface LecteurState {
	actions: Action[];
	index: number;
	data: any;
	base64: any;
	result: any;
	resultLectureCVADR: any;
	resultInsi: any;
	assertionCps: any;
	loading: boolean;
	currentIdAction: string;
	options: any;
	stoppedWithError: any;
	loaded: boolean;
	init: boolean;
	errorActionType: any;
	adrResponse: any;
	errorWSCps: any;
	urlMissingCounter: number;
	isInsi: any;
	shouldRetry: number;
	reponseLecteur: ReponseLecteur;
}

export const lecteurInitialState: LecteurState = {
	actions: [],
	index: 0,
	data: null,
	base64: null,
	result: null,
	resultLectureCVADR: null,
	resultInsi: null,
	assertionCps: null,
	loading: false,
	currentIdAction: null,
	options: null,
	stoppedWithError: null,
	loaded: false,
	init: true,
	errorActionType: null,
	adrResponse: null,
	errorWSCps: null,
	urlMissingCounter: 0,
	isInsi: null,
	shouldRetry: 0,
	reponseLecteur: null,
};

export function lecteurReducer(state: LecteurState = lecteurInitialState, action: LecteurAction) {
	switch (action.type) {
		case LecteurActionTypes.InitAction: {
			if (state.loading) {
				return { ...state };
			}

			return {
				...state,
				actions: action.payload.actions,
				needCodePorteur: action.payload.needCodePorteur,
				result: null,
				stoppedWithError: null,
				resultInsi: null,
				base64: "",
				init: true,
				index: 0,
				loading: true,
				loaded: false,
				errorActionType: null,
				options: action.payload.options,
				currentIdAction: action.payload.id,
				errorWSCps: null,
				urlMissingCounter: 0,
				reponseLecteur: null,
			};
		}

		case LecteurActionTypes.ActionSuccess: {
			return {
				...state,
				data: action.payload?.data,
				index: state.index + 1,
				urlMissingCounter: 0,
			};
		}
		case LecteurActionTypes.SetResultLectureCVADR: {
			return {
				...state,
				resultLectureCVADR: action.payload,
			};
		}
		case LecteurActionTypes.SetBase64: {
			return {
				...state,
				base64: action.payload,
			};
		}
		case LecteurActionTypes.EndAction: {
			return {
				...state,
				result: state.data,
				stoppedWithError: null,
				actions: [],
				index: 0,
				loaded: true,
				loading: false,
				init: state.options?.skipGuideLecteur !== undefined,
				currentIdAction: null,
				errorWSCps: null,
			};
		}

		case LecteurActionTypes.ResetInited: {
			return {
				...state,
				init: false,
				result: null,
				reponseLecteur: null,
				stoppedWithError: null,
				loading: false,
				loaded: false,
				currentIdAction: null,
			};
		}

		case LecteurActionTypes.GetAssertionCPSSuccess: {
			return {
				...state,
				assertionCps: action.payload,
				result: null,
				reponseLecteur: null,
			};
		}

		case LecteurActionTypes.CallAdrWebService: {
			return {
				...state,
				stoppedWithError: null,
				adrResponse: null,
				loading: true,
				loaded: false,
			};
		}

		case LecteurActionTypes.CallAdrWebServiceSuccess: {
			return {
				...state,
				loading: false,
				loaded: true,
				adrResponse: action.payload,
			};
		}

		case LecteurActionTypes.CallInsiWebService: {
			return {
				...state,
				stoppedWithError: null,
				resultInsi: null,
				loading: true,
				loaded: false,
			};
		}

		case LecteurActionTypes.CallInsiWebServiceSuccess: {
			return {
				...state,
				loading: false,
				loaded: true,
				resultInsi: action.payload,
			};
		}

		case LecteurActionTypes.GetInsiActiveSuccess: {
			return {
				...state,
				loading: false,
				loaded: true,
				isInsi: action.payload,
			};
		}

		case LecteurActionTypes.IncrementMissingUrlAmc: {
			return {
				...state,
				urlMissingCounter: state.urlMissingCounter + 1,
			};
		}

		case LecteurActionTypes.IncrementShouldRetry: {
			return {
				...state,
				shouldRetry: action.payload + 1,
			};
		}

		case LecteurActionTypes.SetResult: {
			return {
				...state,
				result: action.payload,
			};
		}

		case LecteurActionTypes.SetReponseLecteur: {
			return {
				...state,
				reponseLecteur: action.payload,
			};
		}

		case LecteurActionTypes.ResetAction: {
			return {
				...state,
				actions: [],
				data: null,
				index: 0,
				base64: "",
				loading: false,
				loaded: false,
				init: false,
				currentIdAction: null,
				errorWSCps: null,
				shouldRetry: 0,
			};
		}

		case LecteurActionTypes.ActionStoppedWithError: {
			return {
				...state,
				stoppedWithError: action.payload,
				reponseLecteur: { error: action.payload },
				loading: false,
			};
		}

		case LecteurActionTypes.ActionPluginError: {
			return {
				...state,
				errorActionType: action.payload,
				loading: false,
			};
		}

		case LecteurActionTypes.VerifyCPSValidityError: {
			return {
				...state,
				errorWSCps: action.payload,
			};
		}

		default:
			return state;
	}
}
